import { render, staticRenderFns } from "./DistribucionPVP.vue?vue&type=template&id=a2d2e968&scoped=true"
import script from "./DistribucionPVP.vue?vue&type=script&lang=js"
export * from "./DistribucionPVP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d2e968",
  null
  
)

export default component.exports